import { useNavigate } from 'react-router-dom';

interface Props {
  to: string;
  label?: string;
}

/**
 * 상세 페이지 우측 상단의 "목록으로" 뒤로가기 버튼.
 * Detail 3곳(AdverDetail, NoticeDetail, MemberDetail)에서 동일한 스타일로 반복됐기 때문에 추출.
 */
export default function BackButton({ to, label = '목록으로' }: Props) {
  const navigate = useNavigate();
  return (
    <button
      onClick={() => navigate(to)}
      className="px-5 py-2.5 bg-gray-500 text-white rounded-lg hover:bg-gray-600 transition-colors flex items-center space-x-2"
    >
      <i className="fas fa-arrow-left"></i>
      <span>{label}</span>
    </button>
  );
}
